import { render, staticRenderFns } from "./playerIndex.vue?vue&type=template&id=324d6af2&scoped=true"
import script from "./playerIndex.vue?vue&type=script&lang=js"
export * from "./playerIndex.vue?vue&type=script&lang=js"
import style0 from "./playerIndex.vue?vue&type=style&index=0&id=324d6af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d6af2",
  null
  
)

export default component.exports